import { useQuery } from "@tanstack/react-query";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { StatementHistoryItem } from "lib/api-types/schemas";
import { getApiCcofPracticeIdPatientsPatientIdStatementHistory } from "@/lib/api-client/endpoints/patient-a-r/patient-a-r";

export const statementHistoryQueryKey = (
  practiceId: string,
  patientId: string,
) => ["patient-ar", "statement-history", practiceId, patientId] as const;

export function useStatementHistory(patientId: string | null) {
  const { tenantId } = useTenantRouteContext();

  return useQuery<StatementHistoryItem[]>({
    queryKey: statementHistoryQueryKey(tenantId, patientId ?? ""),
    queryFn: () =>
      getApiCcofPracticeIdPatientsPatientIdStatementHistory(
        tenantId,
        patientId!,
      ).then((res) => res.data),
    enabled: patientId !== null,
  });
}
